export default [
  {
    name: 'profile',
    title: 'user.menu.profile',
    to: '/account',
    iconClass: 'fas fa-user',
  },
  {
    name: 'password',
    title: 'user.menu.password',
    iconClass: 'fas fa-key',
    to: '/account/reset_password',
  },
];
